// src/components/MessengerChat.js
import React from "react";
import { motion } from "framer-motion";

export default function MessengerChat() {
  return (
    <motion.a
      href="https://m.me/aimbleph"
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      style={{
        position: "fixed",
        bottom: "32px",
        left: "32px", // Placed on the left to balance the 'Back to Top' arrow on the right
        zIndex: 9999,
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        background: "#006AFF", // Official Meta Messenger Blue
        color: "#ffffff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 14px rgba(0, 106, 255, 0.4)",
        cursor: "pointer",
      }}
      aria-label="Chat with us on Messenger"
    >
      {/* Clean, professional SVG Chat Icon */}
      <svg 
        width="30" 
        height="30" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2.2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      >
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>
      </svg>
    </motion.a>
  );
}